export const rolePermissions = [

  /* ======== Inventory Permissions (Structured) ======== */

  // --- Product Management ---
  { name: "Product Management", key: "InventoryProducts", module: "Product Management", type: 'inventoriam', notAllowedKeys: ['approve', 'reject'], url: 'inventory/product' },
  { name: "Manage Retail Price Breaks", key: "InventoryProduct", module: "Product Management", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'viewCost', 'editCost'], url: 'RetailPrice' },
  { name: "Manage Units of Measure", key: "InventoryUOM", module: "Product Management", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'viewCost', 'editCost'], url: 'uom' },
  { name: "Manage Brands", key: "InventoryBrand", module: "Product Management", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'viewCost', 'editCost'], url: 'brands' },
  // { name: "Manage Categories", key: "InventoryCategories", module: "Product Management", type: 'inventoriam' },
  { name: "Manage Subcategories", key: "InventorySubcategory", module: "Product Management", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'viewCost', 'editCost'], url: 'subcategory' },
  { name: "Manage Infused By", key: "InfusedBy", module: "Product Management", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'viewCost', 'editCost'], url: 'infused-by' },

  // --- Locations ---
  { name: "Basement Hub", key: "Inventory", module: "Locations", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'viewCost', 'editCost'], url: 'inventory' },
  { name: "Retail Inventory", key: "RetailInventory", module: "Locations", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'viewCost', 'editCost'], url: 'inventoryRetail' },
  { name: "Bundle Inventory Hub", key: "BoxInventory", module: "Locations", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'viewCost', 'editCost'], url: 'boxInventory' },
  { name: "Bundle Hub", key: "BoxHub", module: "Locations", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'viewCost', 'editCost'], url: 'boxHub' },

  // { name: "Assign Location Access", key: "AssignLocationAccess", module: "Locations", type: 'inventoriam', allowedKeys: ['read', 'edit'] },
  // { name: "Restrict by Specific Location", key: "RestrictLocation", module: "Locations", type: 'inventoriam', allowedKeys: ['read', 'edit'] },

  // --- Purchase Orders ---
  { name: "Purchase Orders", key: "PurchaseManagement", module: "Purchase Orders", type: 'inventoriam', notAllowedKeys: ['delete'], url: 'po' },
  { name: "Purchase History", key: "PurchaseHistory", module: "Purchase Orders", type: 'inventoriam', allowedKeys: ['read'], url: 'po/history' },

  // --- Transfers ---
  { name: "Transfers", key: "TransferManagement", module: "Transfers", type: 'inventoriam', notAllowedKeys: ['delete', 'viewCost', 'editCost'], url: 'internal-transfer' },
  { name: "Transfer History", key: "TransferHistory", module: "Transfers", type: 'inventoriam', allowedKeys: ['read'], url: 'internal-transfer/history' },

  // --- Conversions ---
  { name: "Conversions", key: "ConversionManagement", module: "Conversions", type: 'inventoriam', notAllowedKeys: ['delete', 'viewCost', 'editCost'], url: 'conversion' },
  { name: "Conversion History", key: "ConversionHistory", module: "Conversions", type: 'inventoriam', allowedKeys: ['read'], url: 'conversion/history' },

  // --- Reconciles ---
  { name: "Reconciles", key: "ReconcileManagement", module: "Reconciles", type: 'inventoriam', notAllowedKeys: ['delete', 'viewCost', 'editCost'], url: 'inventoryReconcile' },
  { name: "Reconcile History", key: "ReconcileHistory", module: "Reconciles", type: 'inventoriam', allowedKeys: ['read'], url: 'inventoryReconcile/history' },
  { name: "Reconcile Reasons", key: "ReconcileReason", module: "Reconciles", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'viewCost', 'editCost'], url: 'reasons' },

  // --- Thresholds ---
  { name: "Thresholds", key: "InventoryThreshold", module: "Thresholds", type: 'inventoriam', notAllowedKeys: ['delete', 'approve', 'reject', 'viewCost', 'editCost'], url: 'thresholds' },
  { name: "Threshold Dashboard", key: "ThresholdDashboard", module: "Thresholds", type: 'inventoriam', allowedKeys: ['read'], url: 'thresholds/dashboard' },
  { name: "Threshold Actions", key: "ThresholdActions", module: "Thresholds", type: 'inventoriam', notAllowedKeys: ['delete', 'approve', 'reject', 'viewCost', 'editCost'] },
  { name: "Family Management", key: "FamilyManagement", module: "Thresholds", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'viewCost', 'editCost'], url: 'thresholds/families' },
  // --- Barcodes / QR Codes ---
  { name: "Barcodes", key: "BarCodeManagement", module: "Barcodes / QR Codes", type: 'inventoriam', notAllowedKeys: ['delete', 'approve', 'reject', 'edit', 'viewCost', 'editCost'], url: 'inventory/barcode' },
  // { name: "Print Barcodes", key: "PrintBarcodes", module: "Barcodes / QR Codes", type: 'inventoriam', allowedKeys: ['read'] },
  { name: "QR Codes for Shared Experiences", key: "QRCodeShared", module: "Barcodes / QR Codes", type: 'inventoriam', notAllowedKeys: ['delete', 'viewCost', 'editCost'], url: 'inventory/qrcode' },
  // { name: "Barcode Settings", key: "BarcodeSettings", module: "Barcodes / QR Codes", type: 'inventoriam', allowedKeys: ['read', 'edit'] },

  // --- Vendors ---
  { name: "Vendors", key: "VendorProducts", module: "Vendors", type: 'inventoriam', notAllowedKeys: ['delete', 'viewCost', 'editCost'], url: 'inventory/vendor' },
  { name: "Vendor Requests", key: "VendorRequests", module: "Vendors", type: 'inventoriam', notAllowedKeys: ['approve', 'reject', 'delete', 'viewCost', 'editCost'], url: 'inventory/vendor/request' },

  // --- Global Activity Timeline ---
  { name: "Global Activity Timeline", key: "ActivityTimeline", module: "Global Activity Timeline", type: 'inventoriam', allowedKeys: ['read'], url: 'inventory/activity/timeline' },
  { name: "Filter Timeline", key: "FilterTimeline", module: "Global Activity Timeline", type: 'inventoriam', allowedKeys: ['read'] },
  { name: "Export Timeline", key: "ExportTimeline", module: "Global Activity Timeline", type: 'inventoriam', allowedKeys: ['read'] },
  // { name: "View Sensitive Logs", key: "SensitiveLogs", module: "Global Activity Timeline", type: 'inventoriam', allowedKeys: ['read'] },

  {
    name: "Manage Automation Content",
    key: "Automation",
    url: 'automation'
  },


  /* Groove Guide  permissions */
  // {
  //   name: "Cancel Membership",
  //   key: "CancelMembership",
  //   url:''
  // },
  {
    name: "Membership Status",
    key: "MembershipStatus",
    type: 'loyal_member',
    allowedKeys: ['edit']
  },
  {
    name: "Cancel Membership",
    key: "CancelMembership",
    type: 'loyal_member',
    allowedKeys: ['edit']
  },
  {
    name: "Refund",
    key: "Refund",
    type: 'loyal_member',
    allowedKeys: ['edit']
  },
  {
    name: "Analytics",
    key: "Dashboard",
    url: 'dashboard',
    urls: ['/marketing/seo/reporting'],
  },
  {
    name: "Manage Staff",
    key: "staff",
    url: 'user'
  },

  {
    name: "Manage Membership",
    key: "Plan",
    url: 'plans'
  },
  {
    name: "Manage Sales",
    key: "Order",
    url: 'orders'
  },
  {
    name: "Order Fulfillment",
    key: "OrderFulfillment",
    url: 'order-fulfillment',
    allowedKeys: ['read'],
  },
  {
    name: "Membership Sales",
    key: "Subscription",
    url: 'subscription'
  },

  {
    name: "Manage Onboarding Questions",
    key: "onboardingQuestions",
    type: 'groove_guide',
    url: 'question'
  },
  {
    name: "Manage Survey",
    key: "Survey",
    type: '',
    url: 'survey',
  },
  {
    name: "Manage Contacts",
    key: "grooveGroup",
    type: 'groove_guide',
    url: 'customers'
  },
  {
    name: "Manage Content Categories",
    key: "Categories",
    type: 'groove_guide',
    url: 'category'
  },
  {
    name: "Kiosk Management",
    key: "KioskManagement",
    type: 'groove_guide',
    allowedKeys: ['read', 'edit'],
    url: 'kiosk-management'
  },
  {
    name: "Manage Products",
    key: "Products",
    type: 'groove_guide',
    url: 'product'
  },
  // {
  //   name: "Manage Infused By",
  //   key: "InfusedBy",
  //   type: 'groove_guide',
  //   url: 'strain'
  // },
  {
    name: "Manage Deals",
    key: "Deal",
    type: 'groove_guide',
    url: 'deal'
  },
  {
    name: "Manage Tags",
    key: "Tags",
    type: 'groove_guide',
    url: 'tag'
  },
  {
    name: "Manage Merch",
    key: "Merch",
    type: 'groove_guide',
    url: 'merch-category'
  },
  {
    name: "Manage This Month's Bundle",
    key: "MonthBox",
    type: 'groove_guide',
    url: 'month-box'
  },
  {
    name: "Manage Banners",
    key: "Banners",
    type: 'groove_guide',
    url: 'banner'
  },
  {
    name: "Manage Members",
    key: "Member",
    type: 'loyal_member',
    url: 'member'
  },
  {
    name: "ID Verification Settings",
    key: "CheckinSettings",
    type: 'loyal_member',
    allowedKeys: ['edit'],
    url: 'checkin-settings'
  },
  {
    name: "Manage Checkin",
    key: "Checkin",
    type: 'loyal_member',
    url: 'checkin'
  },
  {
    name: "Manage Referrals",
    key: "Referrals",
    type: 'loyal_member',
    url: 'referrals'
  },
  {
    name: "Bundle Management",
    key: "Box",
    type: 'loyal_member',
    url: 'box-management'
  },
  {
    name: "Manage Reward Requests",
    key: "RewardRequest",
    url: 'reward-request',
    type: 'loyal_member',
  },
  {
    name: "Manage Reward History Report",
    key: "RewardHistoryReport",
    url: 'wallet-points',
    type: 'loyal_member',
  },
  {
    name: "Manage Reward Types",
    key: "RewardTypes",
    url: 'reward-type',
    type: 'loyal_member'
  },
  {
    name: "Manage Discount Report",
    key: "DiscountReport",
    url: 'discount-report',
    type: 'loyal_member'
  },

  {
    name: "Next Payment Date",
    key: "NextPymentDate",
    url: 'checkin',
    type: 'loyal_member',
    allowedKeys: ['edit']
  },
  {
    name: "Content Management",
    key: "Content",
    url: 'content',
    urls: [
      'this-week-playlist', 'blog', 'audio', 'videos', 'resources', 'faq', 'newsletter'],
  },
  {
    name: "Manage Experience and Benefits",
    key: "ShareExperience",
    url: 'share-experience',
    urls: ['tag']
  },
  {
    name: "Manage Broadcast",
    key: "Broadcast",
    url: 'notifications'
  },

  {
    name: "Live Page Settings",
    key: "LiveSettings",
    url: "live-settings",
  },

  /*EVA permissions start*/
  {
    name: "Agents",
    key: "Agents",
    url: "agent",
    type: "eva",
  },
  {
    name: "Call Logs",
    key: "CallLogs",
    url: "call-logs",
    type: "eva",
  },
  {
    name: "Call Analytics",
    key: "CallAnalytics",
    url: "call-analytics",
    type: "eva",
  },
  {
    name: "Call Rating",
    key: "CallRating",
    url: "call-rating",
    type: "eva",
  },
  {
    name: "Fallback Handling",
    key: "FallbackHandling",
    url: "fallback-handling",
    type: "eva",
  },
  {
    name: "Messaging Inbox",
    key: "MessagingInbox",
    url: "messaging-inbox",
    type: "eva",
  },


  /*EVA permissions end*/

  /* ======== Groove Grill Permissions ======== */

  // --- Groove Grill: Weekly Meals ---
  // { name: "Weekly Meal Orders", key: "WeeklyMealOrders", module: "Groove Grill", type: 'groove_grill', notAllowedKeys: ['approve', 'reject'] },
  // { name: "Groove Meal Plans", key: "GrooveMealPlans", module: "Groove Grill", type: 'groove_grill', notAllowedKeys: ['approve', 'reject'] },
  // { name: "Groove Meal Type", key: "GrooveMealType", module: "Groove Grill", type: 'groove_grill', notAllowedKeys: ['approve', 'reject'] },
  // { name: "Most Popular Grooves", key: "MostPopularGrooves", module: "Groove Grill", type: 'groove_grill', notAllowedKeys: ['approve', 'reject'] },
  // { name: "Groove Build Your Own", key: "GrooveBuildYourOwn", module: "Groove Grill", type: 'groove_grill', notAllowedKeys: ['approve', 'reject'] },
  // { name: "Groove Extra Meals", key: "GrooveExtraMeals", module: "Groove Grill", type: 'groove_grill', notAllowedKeys: ['approve', 'reject'] },
  // { name: "Groove Drinks", key: "GrooveDrinks", module: "Groove Grill", type: 'groove_grill', notAllowedKeys: ['approve', 'reject'] },
  // { name: "Groove Location / Tax", key: "GrooveLocation", module: "Groove Grill", type: 'groove_grill', notAllowedKeys: ['approve', 'reject', 'delete'] },

  // // --- Groove Grill: Events & Catering ---
  // { name: "Groove Events", key: "GrooveEvents", module: "Groove Grill", type: 'groove_grill', notAllowedKeys: ['approve', 'reject'] },
  // { name: "Groove Catering", key: "GrooveCatering", module: "Groove Grill", type: 'groove_grill', notAllowedKeys: ['approve', 'reject'] },
  // { name: "Groove Event Requests", key: "GrooveEventRequest", module: "Groove Grill", type: 'groove_grill', notAllowedKeys: ['delete'] },

  // /* ======== Monthly Boxes ======== */
  // { name: "Monthly Boxes", key: "MonthlyBoxes", module: "Monthly Boxes", type: 'loyal_member', notAllowedKeys: ['approve', 'reject'] },
];

export const rolePermission = [
  { name: "Read", key: "read" },
  { name: "Add", key: "add" },
  { name: "Edit", key: "edit" },
  { name: "Approve", key: "approve" },
  { name: "Reject", key: "reject" },
  { name: "Delete", key: "delete" },
  { name: "View Cost", key: "viewCost" },
  { name: "Edit Cost", key: "editCost" },
];

export const roleGetAllKeys = () => {
  let keys = {};
  rolePermissions.map((itm) => {
    rolePermission.map((pitm) => {
      keys = { ...keys, [`${pitm.key}${itm.key}`]: false };
    });
  });

  return keys;
};

export const flavourOptions = [
  { id: "Dark Chocolate", name: "Dark Chocolate" },
  { id: "Cookies & Cream", name: "Cookies & Cream" },
  { id: "Milk Chocolate", name: "Milk Chocolate" },
  { id: "Dark Cherry", name: "Dark Cherry" },
  { id: "Butterfinger", name: "Butterfinger" },
  { id: "Smores", name: "Smores" },
  { id: "Crunch", name: "Crunch" },
  { id: "Fruity Pebbles", name: "Fruity Pebbles" },
  { id: "Cinnamon Toast Crunch", name: "Cinnamon Toast Crunch" },
  { id: "Magic Bar", name: "Magic Bar" },
  { id: "Mushee", name: "Mushee" },
  { id: "Groove Tea", name: "Groove Tea" },
  { id: "Strawberry", name: "Strawberry" },
  { id: "Peppermint", name: "Peppermint" },
  { id: "Milk Chocolate + Cookies & Cream", name: "Milk Chocolate + Cookies & Cream" },
  { id: "Mixed Berry", name: "Mixed Berry" },
  { id: "Citrus + Blood Orange", name: "Citrus + Blood Orange" },
  { id: "Tangy + Mango", name: "Tangy + Mango" },
  { id: "Mixed Fruit (Strawberry, Lemon, Cherry)", name: "Mixed Fruit (Strawberry, Lemon, Cherry)" },
  { id: "Chai Coconut & Biscoff Cookie", name: "Chai Coconut & Biscoff Cookie" },
  { id: "Pandan Cookies & Cream", name: "Pandan Cookies & Cream" },
  { id: "Dark Choc & Cacao Nibs", name: "Dark Choc & Cacao Nibs" },
  { id: "Strawberry Cardamom & Pistachio", name: "Strawberry Cardamom & Pistachio" },
  { id: "Butterfly Pea Flower", name: "Butterfly Pea Flower" },
  { id: "Cinna Apple", name: "Cinna Apple" },
  { id: "Black Lemon", name: "Black Lemon" },
  { id: "Jasmine Bud", name: "Jasmine Bud" },
  { id: "Lavender Vanilla", name: "Lavender Vanilla" },
  { id: "Blueberry Lemon", name: "Blueberry Lemon" },
  { id: "Watermelon Mint", name: "Watermelon Mint" },
  { id: "Cinnamon", name: "Cinnamon" },
  { id: "Matcha Lemongrass & Ginger", name: "Matcha Lemongrass & Ginger" },
  { id: "Hibiscus & Pomegranate", name: "Hibiscus & Pomegranate" },
  { id: "Orange Clove Mint", name: "Orange Clove Mint" },
  { id: "Thin Mint", name: "Thin Mint" },
  { id: "Red Velvet", name: "Red Velvet" },
  { id: "Reese's", name: "Reese's" },
  { id: "Milk", name: "Milk" },
  { id: "Strawberries & Cream", name: "Strawberries & Cream" },
  { id: "Red Bone", name: "Red Bone" },
  { id: "Blue Razz", name: "Blue Razz" },
  { id: "Pink Lemonade", name: "Pink Lemonade" },
  { id: "Orange Kels", name: "Orange Kels" },
  { id: "Green Apple", name: "Green Apple" },
  { id: "Pineapple", name: "Pineapple" },
  { id: "Fruit Punch", name: "Fruit Punch" },
  { id: "Coconut Water & Lemon", name: "Coconut Water & Lemon" },
  { id: "Milk Chocolate Mix", name: "Milk Chocolate Mix" },
  { id: "Apple Cinnamon", name: "Apple Cinnamon" },
  { id: "Fruit", name: "Fruit" },
  { id: "Peanut Butter Milk Chocolate", name: "Peanut Butter Milk Chocolate" },
  { id: "White Chocolate Strawberries", name: "White Chocolate Strawberries" },
  { id: "Honey Ginger", name: "Honey Ginger" },
  { id: "Milk Chocolate Peppermint", name: "Milk Chocolate Peppermint" },
  { id: "Birthday Cake", name: "Birthday Cake" },
  { id: "Coco Powder", name: "Coco Powder" },
  { id: "Milk Chocolate Toffee", name: "Milk Chocolate Toffee" },
  { id: "Mango", name: "Mango" },
  { id: "Lychee", name: "Lychee" },
  { id: "Strawberry Cheesecake", name: "Strawberry Cheesecake" },
  { id: "Assorted", name: "Assorted" },
  { id: "Original", name: "Original" },
  { id: "Pistachio Dubai Style", name: "Pistachio Dubai Style" },
  { id: "Butter Fingers", name: "Butter Fingers" },
  { id: "Cinnamon Crunch", name: "Cinnamon Crunch" },
  { id: "Fire Cracker", name: "Fire Cracker" },
  { id: "Espresso", name: "Espresso" },
  { id: "Fruit Nut", name: "Fruit Nut" },
  { id: "Coconut", name: "Coconut" },
  { id: "Sea Salt Caramel", name: "Sea Salt Caramel" },
  { id: "Caramel", name: "Caramel" },
  { id: "Toffee", name: "Toffee" },
  { id: "White Chocolate", name: "White Chocolate" },
  { id: "Cookie Dough", name: "Cookie Dough" },
  { id: "Vegan Fruit Nut", name: "Vegan Fruit Nut" },
  { id: "Dark Chocolate Sea Salt", name: "Dark Chocolate Sea Salt" },
  { id: "Dark Chocolate Cherry", name: "Dark Chocolate Cherry" },
  { id: "Nerds", name: "Nerds" },
  { id: "Tajin Citrus", name: "Tajin Citrus" },
  { id: "Tajin Berry", name: "Tajin Berry" },
  { id: "Blue Raspberries", name: "Blue Raspberries" },
  { id: "Strawberry Lemonade", name: "Strawberry Lemonade" },
  { id: "Strawberries", name: "Strawberries" },
  { id: "Cherry Lime Aid", name: "Cherry Lime Aid" },
  { id: "Pina Colada", name: "Pina Colada" },
  { id: "Watermelon Tajin", name: "Watermelon Tajin" },
  { id: "Lime Aid", name: "Lime Aid" },
  { id: "Creamsicle", name: "Creamsicle" },
  { id: "Milk Almonds", name: "Milk Almonds" },
  { id: "Salted Caramel", name: "Salted Caramel" },
  { id: "Peanut Butter", name: "Peanut Butter" },
  { id: "Blend", name: "Blend" },
  { id: "Toasted Coconut", name: "Toasted Coconut" },
  { id: "Pumpkin Latte", name: "Pumpkin Latte" },
  { id: "Peppermint Crunch", name: "Peppermint Crunch" },
  { id: "Fruit & Heath Nut", name: "Fruit & Heath Nut" },
  { id: "Heath Toffee", name: "Heath Toffee" },
  { id: "Roselle Noir", name: "Roselle Noir" },
  { id: "Golden Morning", name: "Golden Morning" },
  { id: "Orange Sea Salt", name: "Orange Sea Salt" },
  { id: "Pistachio & Saffron", name: "Pistachio & Saffron" },
  { id: "Dandelion & Blood Orange", name: "Dandelion & Blood Orange" },
  { id: "Strawberry Basil", name: "Strawberry Basil" },
  { id: "Mango Chili", name: "Mango Chili" },
  { id: "Pistachio", name: "Pistachio" },
  { id: "Crunch Bites", name: "Crunch Bites" },
  { id: "Wild Orange", name: "Wild Orange" },
  { id: "Lavender & Rose", name: "Lavender & Rose" },
  { id: "Sea Salt", name: "Sea Salt" },
  { id: "Peach Street", name: "Peach Street" },
  { id: "Limon", name: "Limon" },
  { id: "Island Fruit Pineapple", name: "Island Fruit Pineapple" },
  { id: "Watermelon", name: "Watermelon" },
  { id: "Berry Twist", name: "Berry Twist" },
  { id: "Berry", name: "Berry" },
  { id: "Slimy Limon", name: "Slimy Limon" },
  { id: "Purple Kind", name: "Purple Kind" },
  { id: "Cherry", name: "Cherry" },
  { id: "Boom Punch", name: "Boom Punch" },
  { id: "Blueberry Lemonade", name: "Blueberry Lemonade" },
  { id: "Crushed Peanuts", name: "Crushed Peanuts" },
  { id: "Peanut Butter Cup", name: "Peanut Butter Cup" },
  { id: "Funfetti", name: "Funfetti" },
  { id: "Sour Martaneli", name: "Sour Martaneli" },
  { id: "Misc. C7", name: "Misc. C7" },
  { id: "Misc. SG", name: "Misc. SG" },
];




export const userType = {
  id: "",
  fullName: "",
  role: "",
  email: "",
  mobileNo: "",
  aboutUs: "",
  address: "",
  image: "",
  logo: "",
};
export const CategoryType = {
  id: "",
  name: "",
  catType: "",
  subParentCategory: "",
  description: "",
  image: "",
  order: "",
  parentCategory: "",
  status: "active",
  icon: "",
  banner: "",
  altImageName: "",
  altIconName: "",
  bannerOverlayHeading: "",
  bannerOverlayBody: "",
  description: "",
  featured: "No",
  urlKey: "",
  metaTitle: "",
  metaDescription: "",
  keywords: "",
};
export const roleType = {
  id: "",
  name: "",
  status: "active",
  permissions: roleGetAllKeys(),
};
export const resellerCategoryType = {
  id: "",
  name: "",
  catType: "Reseller",
  description: "",
  image: "",
};
export const planType = {
  id: "",
  name: "",
  price: "",
  status: "active",
  interval: "Monthly",
  category: "",
  recommended: "",
  allowedProducts: "",
  feature: [],
  monthlyPrice: "",
  threeMonthPrice: "",
  sixMonthPrice: "",
  yearlyPrice: "",
  extraProductPrice: "",
};
export const continentType = { id: "", name: "", status: "active" };
export const featureType = {
  id: "",
  name: "",
  description: "",
  status: "active",
};
export const emailType = { id: "", subject: "", content: "", status: "active" };
export const cityType = {
  id: "",
  name: "",
  status: "active",
  countryId: "",
  regionId: "",
  continent: "",
};
export const bookingSystemType = {
  id: "",
  name: "",
  apiKey: "",
  secretKey: "",
};
export const holidaysType = {
  id: "",
  discOrPre: "",
  name: "",
  type: "",
  country: "",
  counties: "",
  amountOrPercent: "",
  number: "",
  applyFor: [],
  preOrPost: "",
  preDays: "",
  postDays: "",
  changesApply: "",
  changesDate: "",
  changesDateTo: "",
};
export const earlybirdpricingType = {
  id: "",
  name: "",
  discOrPre: "",
  startDate: "",
  country: "",
  counties: "",
  applyEarlyBirdPricing: [],
  endDate: "",
  inventory: [],
  lastMinutePricingFromDate: "",
  lastMinutePricingToDate: "",
  applyPriceType: "",
  changesDate: "",
  changesDateTo: "",
  notApply: "",
  notApplyCondition: "",
  notApplicableFor: [],
  blackOutDates: [],
  amountOrPercent: "",
  number: "",
  applyToDaysTimeSlot: "",
  daysToApply: [],
  timeSlots: [],
};
export const posType = { id: "", name: "", apiKey: "", url: "" };

export const resellerType = {
  id: "",
  name: "",
  logo: "",
  category: "",
  contractDate: "",
  booking: "",
  country: "",
  contactPerson: "",
  contactPhone: "",
  contactEmail: "",
  website: "",
};
export const couponType = {
  id: "",
  title: "",
  status: "active",
  description: "",
  couponCode: "",
  usesPerCoupon: "",
  usesPerCustomer: "",
  dateFrom: "",
  dateTo: "",
  discountType: "",
  discountAmount: "",
};
